import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'sb-custom-icons',
  templateUrl: './custom-icons.component.html',
  styleUrls: ['./custom-icons.component.scss'],
  standalone: false,
})
export class CustomIconsComponent implements OnInit {
  @Input() name: string;

  constructor() {}

  ngOnInit() {}

  get absUrl() {
    return window.location.href.split('#')[0];
  }
}
